import type { AppContext } from 'vue'

export const useAppContext: {
  appContext: AppContext | null
  setAppContext: (appContext: AppContext) => void
} = {
  appContext: null,
  setAppContext(appContext) {
    this.appContext = appContext
  },
}
